import SendIcon from "@/assets/images/icons/send.svg?inline";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import DeleteIcon from "@/assets/images/icons/delete.svg?inline";
import EditIcon from "@/assets/images/icons/edit-message.svg?inline";
import CloseIcon from "@/assets/images/icons/close.svg?inline";
import BackIcon from "@/assets/images/icons/back.svg?inline";
import AvatarIcon from "@/assets/images/icons/chat_avatar.svg?inline";

import debounce from "lodash/debounce";

export default {
  name: "messages_list",

  data() {
    return {
      message: "",
      previousScrollPosition: "",
      isLoadingPrevMessages: false,

      isEditMode: false,
      editableMessage: {},

      isShowPlaceholder: false
    };
  },

  props: {
    messages: Array,
    userData: Object,
    channelData: Array,
    isInitChannel: Boolean,
    hasMoreMessages: Boolean
  },

  computed: {
    me() {
      if (this.channelData.length) {
        let me = this.channelData.find(u => {
          return u.id == this.userData.id;
        });

        return me;
      }
    },

    opponent() {
      if (this.channelData.length) {
        let opponent = this.channelData.find(u => {
          return u.id != this.userData.id;
        });

        return opponent;
      }
    },

    isMobile() {
      return this.$mq === "md" || this.$mq === "sm" || this.$mq === "xs";
    }
  },

  mounted: function() {},

  methods: {
    addMessage() {
      if (this.message.length > 0 && this.isInitChannel) {
        if (this.isEditMode === true) {
          this.editableMessage.updateBody(this.message).then(newMessage => {
            this.destroyEditMessage();
          });
        } else {
          this.$emit("new-message", this.message);
          this.message = "";
        }
      }
    },

    handleCmdEnter(e) {
      if ((e.metaKey || e.ctrlKey) && e.keyCode == 13) {
        this.addMessage();
      }
    },

    loadMoreMessasges() {
      this.$emit("loadMoreMessasges");

      // save scroll position
      this.isLoadingPrevMessages = true;
      this.previousScrollPosition =
        this.$refs.messagesContainer.scrollHeight -
        this.$refs.messagesContainer.scrollTop;
    },

    handleScroll: debounce(function() {
      if (
        this.$refs.messagesContainer.scrollTop === 0 &&
        this.hasMoreMessages
      ) {
        this.loadMoreMessasges();
      }
    }, 300),

    deleteMessage(message) {
      if (confirm("Do you really want to sign out?")) {
        message.remove().then(data => {
          this.$emit("deleteMessage", data.sid);
        });
      }
    },

    editMessage(message) {
      this.isEditMode = true;
      this.editableMessage = message;
      this.message = this.editableMessage.body;
    },

    destroyEditMessage() {
      this.isEditMode = false;
      this.editableMessage = {};
      this.message = "";
    },

    openOponentInfo() {
      this.$emit("openOponentInfoMobile");
    },

    backToChannelsList() {
      this.$emit("backToChannelsList");
    }
  },

  components: {
    SendIcon,
    LoadingIcon,
    DeleteIcon,
    CloseIcon,
    EditIcon,
    BackIcon,
    AvatarIcon
  },

  watch: {
    messages: function(newMsgs, oldMsgs) {
      if (newMsgs.length == 0 && oldMsgs.length == 0) {
        this.isShowPlaceholder = true;
      } else {
        this.isShowPlaceholder = false;
      }

      if (oldMsgs.length == 0 && newMsgs.length > 0) {
        // first messages loaded
        this.$nextTick(() => {
          let lastMsg = document.querySelector(".chat-message:last-child");
          this.$refs.messagesContainer.scrollTop = lastMsg.offsetTop;
        });
      } else if (oldMsgs.length != 0 && oldMsgs.length == newMsgs.length) {
        this.$nextTick(() => {
          let lastMsg = document.querySelector(".chat-message:last-child");
          this.$refs.messagesContainer.scrollTop = lastMsg.offsetTop;
        });
      } else {
        // next messages loaded

        this.$nextTick(() => {
          this.$refs.messagesContainer.scrollTop =
            this.$refs.messagesContainer.scrollHeight -
            this.previousScrollPosition;
        });
      }
      this.isLoadingPrevMessages = false;
    }
  }
};
